/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
//import '../../css/event210521.css'
//import '../../css/event210629.css'
//import '../../css/event210819.css'
import "../../css/event211020.css";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
import { isMobile } from "react-device-detect";
import $ from "jquery";

class Event20220328_spy extends Component {
  state = {
    eventCode: 0,
    tabIndex: 3,
    slideIndex: 0,
    slidePlay: true,
  };
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $("img[usemap]").rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _google = () => {
    window.open("https://forms.gle/8Dp2hTPaLWRx5GFa6", "", "");
  };
  render() {
    // const { bannerList, tabIndex, slideIndex } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>스파이 패밀리 첫방 일시를 맞춰라</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: "cursor" }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          {isMobile ? (
            <Fragment>
              <map name="Map1">
                <area
                  onClick={this._google}
                  shape="rect"
                  coords="36, 2809, 665, 2897"
                  style={{ cursor: "pointer" }}
                />
              </map>
              <img src="/img/event/event220328/backimg_m1.png" useMap="#Map1" />
            </Fragment>
          ) : (
            <Fragment>
              <map name="Map2">
                <area
                  onClick={this._google}
                  shape="rect"
                  coords="218, 2399, 1493, 2516"
                  style={{ cursor: "pointer" }}
                />
              </map>

              <img src="/img/event/event220328/backimg_1.png" useMap="#Map2" />
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event20220328_spy));
